import { ActionType, IPatchAgency } from './model'
import { Action, ActionCallback, IValidationCallback } from '../model'

export const getClientCompanyAction = (payload: { clientCompanyId: number }): Action<{ clientCompanyId: number }> => ({
  type: ActionType.GET_CLIENT_COMPANY,
  payload,
})

export const getAgencyAction = () => ({
  type: ActionType.GET_AGENCY,
})

export const patchAgencyAction = (
  payload: IPatchAgency,
  callback: IValidationCallback
): ActionCallback<IPatchAgency> => ({
  type: ActionType.PATCH_AGENCY,
  payload,
  callback,
})
